import { render, staticRenderFns } from "./wc-type.vue?vue&type=template&id=2cbb806e&"
import script from "./wc-type.vue?vue&type=script&lang=js&"
export * from "./wc-type.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports